import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">Made With 💜 By Srishti Palani </div>;
}

export default Footer;